var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigureboxing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 23.3549 28.1602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 28.1602,
    opacity: 0,
    width: 23.3549,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8981 5.10938C12.3044 5.10938 13.4411 3.97266 13.4411 2.54297C13.4411 1.13672 12.3044 0 10.8981 0C9.46844 0 8.33173 1.13672 8.33173 2.54297C8.33173 3.97266 9.46844 5.10938 10.8981 5.10938ZM0.421569 27.8203C0.913757 28.2422 1.67548 28.2188 2.13251 27.7031L6.30438 22.9336C6.52704 22.6758 6.65594 22.3945 6.6911 22.0664L7.21844 16.9336C7.23016 16.7578 7.41766 16.6875 7.53485 16.8281L10.8981 20.707L10.8981 26.9062C10.8981 27.5742 11.4372 28.125 12.1169 28.125C12.7731 28.125 13.3356 27.5742 13.3356 26.9062L13.3356 20.3086C13.3356 19.9805 13.2302 19.7578 13.0778 19.5352L9.51532 14.332L11.2497 9.15234C11.3434 8.87109 11.5309 8.76562 11.8122 8.76562L21.1872 8.76562C21.8434 8.76562 22.4059 8.22656 22.4059 7.55859C22.4059 6.89062 21.8434 6.33984 21.1872 6.33984L7.0661 6.33984C6.08173 6.33984 5.28485 6.62109 4.48798 7.40625L2.17938 9.73828C1.40594 10.5234 1.82782 11.8008 2.89423 11.8008L5.07391 11.8008L4.60516 13.1953C4.35907 13.9453 4.24188 14.7188 4.24188 15.4805L4.24188 21.6211L0.304382 26.1094C-0.140931 26.6133-0.0940555 27.375 0.421569 27.8203ZM21.1872 9.99609C22.1833 9.99609 23.0036 9.17578 23.0036 8.15625C23.0036 7.16016 22.1833 6.33984 21.1872 6.33984C20.1677 6.33984 19.3474 7.16016 19.3474 8.15625C19.3474 9.17578 20.1677 9.99609 21.1872 9.99609Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureboxing);
export default __webpack_public_path__ + "static/media/figure.boxing.6e10de8b7098fdf2ec015809c12571de.svg";
export { ForwardRef as ReactComponent };